/**
 * `<promo-popup>` custom element (feature list v1.2).
 *
 * Storage: `thcabina:popup-dismissed` — timestamp of the last dismissal
 * (registered `thcabina:` key). The popup opens after `data-delay` seconds,
 * at most once per `data-frequency-days`; closing it (X, Esc or backdrop)
 * stamps the dismissal. In the theme editor it opens on section select and
 * never stamps anything.
 */
class PromoPopup extends HTMLElement {
  static STORAGE_KEY = 'thcabina:popup-dismissed';

  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;

    this.querySelectorAll('[data-popup-close]').forEach((button) => {
      button.addEventListener('click', () => this.dialog.close());
    });
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
    this.dialog.addEventListener('close', () => this.stamp());

    if (this.hasAttribute('data-design-mode')) {
      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail.sectionId === this.dataset.sectionId) this.open();
      });
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.detail.sectionId === this.dataset.sectionId) this.dialog.close();
      });
      return;
    }

    if (this.hasAttribute('data-disabled') || this.dismissedRecently()) return;
    setTimeout(() => this.open(), Number(this.dataset.delay || 5) * 1000);
  }

  open() {
    if (!this.dialog.open) this.dialog.showModal();
  }

  dismissedRecently() {
    try {
      const at = Number(window.localStorage.getItem(PromoPopup.STORAGE_KEY));
      if (!at) return false;
      const days = Number(this.dataset.frequencyDays || 30);
      return Date.now() - at < days * 24 * 60 * 60 * 1000;
    } catch (error) {
      // storage negato: meglio non mostrare il popup a ogni pagina
      return true;
    }
  }

  stamp() {
    if (this.hasAttribute('data-design-mode')) return;
    try {
      window.localStorage.setItem(PromoPopup.STORAGE_KEY, String(Date.now()));
    } catch (error) {
      /* niente storage, niente memoria: pazienza */
    }
  }
}

if (!customElements.get('promo-popup')) {
  customElements.define('promo-popup', PromoPopup);
}
